import { createRouter, createWebHistory } from 'vue-router';

import type { AuthenticationStart } from '../shared/auth/types.ts';
import { publicFlowRoutes } from '../shared/publicFlows/routes.ts';
import AuthPage from './AuthPage.vue';
import VerificationNotice from './VerificationNotice.vue';

export type RegistrationProduct = {
    name: string;
    slug: string;
    description: string | null;
    color: string;
    iconHtml: string | null;
};

export type PublicContext = {
    intended?: string;
    consumeLinkImmediately?: boolean;
    product?: RegistrationProduct;
};

function stringParam(value: string | string[]): string {
    return Array.isArray(value) ? value[0] : value;
}

export default function createPublicRouter(context: PublicContext) {
    const sharedProps = {
        intended: context.intended,
        product: context.product,
    };

    return createRouter({
        history: createWebHistory(),
        routes: [
            {
                path: '/:mode(login|register)',
                name: 'auth.entry',
                component: AuthPage,
                props: (route) => {
                    const mode = stringParam(route.params.mode) as 'login' | 'register';

                    return {
                        ...sharedProps,
                        start: { screen: 'entry', mode } satisfies AuthenticationStart,
                    };
                },
            },
            {
                path: '/forgot-password',
                name: 'auth.password-recovery',
                component: AuthPage,
                props: {
                    ...sharedProps,
                    start: { screen: 'password-recovery' } satisfies AuthenticationStart,
                },
            },
            {
                path: '/auth/links/:token',
                name: 'auth.link',
                component: AuthPage,
                props: (route) => ({
                    ...sharedProps,
                    start: {
                        screen: 'authentication-link',
                        token: stringParam(route.params.token),
                        consumeImmediately: context.consumeLinkImmediately ?? false,
                    } satisfies AuthenticationStart,
                }),
            },
            {
                path: '/email/verify',
                name: 'verification.notice',
                component: VerificationNotice,
            },
            ...publicFlowRoutes,
        ],
    });
}
